/**
 * The policy assumed for a board that carries none: the column is nullable and
 * a policy can be cleared, so billing still has to resolve to an area.
 */
export const DEFAULT_OUT_OF_AREA_POLICY = "responsible_icb_pays";
//# sourceMappingURL=managedLocations.js.map